import { memo } from "react";

import { translate } from "app/filters/i18nFilter";
import { DAYS_IN_MONTH } from "app/services/date-time/constants";
import dateTimeService from "app/services/date-time/dateTimeService";

import { MORE_THEN_THREE_MONTHS_KEY, NUMBER_DAYS_AGO_KEY, TODAY_KEY, UPDATED_KEY } from "./const";
import { StyledUpdatedInfo } from "./styles";

type LastUpdatedDateProps = { date?: string };

const LastUpdatedDate = ({ date = "" }: LastUpdatedDateProps) => {
    const numberOfDaysAgo = dateTimeService.fromDateToCurrentDate(date);
    const olderThanTwoMonths = numberOfDaysAgo > DAYS_IN_MONTH * 2;

    const getLastUpdatedText = () => {
        if (olderThanTwoMonths) {
            return translate(MORE_THEN_THREE_MONTHS_KEY);
        }

        if (numberOfDaysAgo === 0) {
            return translate(TODAY_KEY);
        }

        return `${numberOfDaysAgo} ${translate(NUMBER_DAYS_AGO_KEY)}`;
    };

    return (
        <StyledUpdatedInfo isOld={olderThanTwoMonths}>
            {`${translate(UPDATED_KEY)}: ${getLastUpdatedText()}`}
        </StyledUpdatedInfo>
    );
};

export default memo(LastUpdatedDate);
